
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { NavDropdown, MenuItem } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import NavBarMenuItem from '../../common/navbar/NavBarMenuItem.js';

import pdf_01 from '../../../assets/pdf/projects/Multithreaded_Webserver.pdf';
import pdf_02 from '../../../assets/pdf/projects/EngModels_and_Simulators.pdf';
import pdf_03 from '../../../assets/pdf/projects/Custom_ETL_Software.pdf';
import pdf_04 from '../../../assets/pdf/checklists/Checklist_Diving_TSBrown.pdf';
import pdf_05 from '../../../assets/pdf/checklists/Checklist_172R_TSBrown.pdf';
import pdf_06 from '../../../assets/pdf/projects/ANTLR_URLGrammar.pdf';

/**
 * Note: Your components tell React what you want to render
 */
class AppNavBar_MyProjects extends React.Component {
	render() {
		return (
      <NavDropdown eventKey={this.props.eventKey} title="My Projects" id="nav-dropdown">
        <NavBarMenuItem eventKey={this.props.eventKey + ".1"} glyph="fire" href={pdf_06}> ANTLR HTTP Grammar</NavBarMenuItem>
        <MenuItem divider />
        <NavBarMenuItem eventKey={this.props.eventKey + ".3"} glyph="fire" href={pdf_01}> Webserver/LMS Project</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".4"} glyph="fire" href={pdf_02}> Engineering Models and Simulators</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".5"} glyph="fire" href={pdf_03}> Custom ETL Software</NavBarMenuItem>
        <MenuItem divider />
        <NavBarMenuItem eventKey={this.props.eventKey + ".4"} glyph="fire" href={pdf_04}> Tracy's Diving Checklist</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".5"} glyph="fire" href={pdf_05}> Tracy's Cessna 172R Checklist</NavBarMenuItem>
      </NavDropdown>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default AppNavBar_MyProjects;



// WEBPACK FOOTER //
// ./src/cba/appspec/header/Nav_AppNavBar_MyProjects.js